import { render, staticRenderFns } from "./ProductOptionSearchPopupIframe.vue?vue&type=template&id=4be15f28&"
import script from "./ProductOptionSearchPopupIframe.vue?vue&type=script&lang=ts&"
export * from "./ProductOptionSearchPopupIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports